import httpClient from './httpClient';
import {
  LocationType,
  LocationTypeListResponse,
  LocationTypeSingleResponse,
  LocationTypeCreateRequest,
  LocationTypeCreateResponse,
  LocationTypeUpdateRequest,
  LocationTypeUpdateResponse,
  LocationTypeDeleteResponse,
} from '../types/settingsLocationTypeModel';

/**
 * Fetches all location types.
 * GET /master/location-type
 */
export const getAllLocationTypes = async (): Promise<LocationType[]> => {
  const { data } = await httpClient.get<LocationTypeListResponse>('/master/location-type');
  if (!data.success) throw new Error(data.message || 'Failed to fetch location types.');
  return data.result.locationTypes;
};

/**
 * Fetches a single location type by ID.
 * GET /master/location-type/:id
 */
export const getLocationTypeById = async (id: string): Promise<LocationType> => {
  const { data } = await httpClient.get<LocationTypeSingleResponse>(`/master/location-type/${id}`);
  if (!data.success) throw new Error(data.message || 'Failed to fetch location type.');
  return data.result;
};

/**
 * Creates a new location type.
 * POST /master/location-type
 */
export const createLocationType = async (
  payload: LocationTypeCreateRequest
): Promise<string> => {
  const { data } = await httpClient.post<LocationTypeCreateResponse>('/master/location-type', payload);
  if (!data.success) throw new Error(data.message || 'Failed to create location type.');
  return data.result.id;
};

/**
 * Updates an existing location type.
 * PUT /master/location-type/:id
 */
export const updateLocationType = async (
  id: string,
  payload: LocationTypeUpdateRequest
): Promise<string> => {
  const { data } = await httpClient.put<LocationTypeUpdateResponse>(
    `/master/location-type/${id}`,
    payload
  );
  if (!data.success) throw new Error(data.message || 'Failed to update location type.');
  return data.result.id;
};

/**
 * Deletes a location type by ID.
 * DELETE /master/location-type/:id
 */
export const deleteLocationType = async (id: string): Promise<void> => {
  const { data } = await httpClient.delete<LocationTypeDeleteResponse>(
    `/master/location-type/${id}`
  );
  if (!data.success) throw new Error(data.message || 'Failed to delete location type.');
};